import { Axios } from 'src/class/Axios.js';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

const methods = {
  handleClose(done) {
    done();
    this.renderContentShowDialog = false;
  },
  handleView(_, row) {
    this.renderContentShowDialog = true;
    this.rowData = { ...row };
    this.openModal('read');
  },
  handleEdit(_, row) {
    sessionStorage.setItem('editForm', JSON.stringify({ ...row }));
    if (this.$slots.dialogForm) {
      this.openModal('create', true);
      this.$emit('openModal', true);
    } else {
      this.$router.push({
        path: `/${this.addProperties.routeToCreate}/edit`,
      });
    }
  },
  handleDelete(_, row) {
    this.model = { ...row };
    const msg = row.messageToDelete
      ? row.messageToDelete
      : `${i18n.t('common_words.record_deactivate')}  "${row.name}"?`;
    SweetAlert.disable(msg).then((result) => {
      if (result.value) this.deleteRecord();
    });
  },
  handleActivate(_, row) {
    this.model = { ...row };
    const msg = row.messageToDelete
      ? row.messageToDelete
      : `${i18n.t('common_words.record_activate')} "${this.model.name}"?`;
    SweetAlert.default(msg, null, i18n.t('common_words.yes_enable'), 1).then(
      (result) => {
        if (result.value) this.activateRecord();
      }
    );
  },
  activateRecord() {
    if (this.isUpdate()) {
      this.showHideLoading(true);
      this.model.route = `${this.getRoute}/activate`;
      Axios.updateMaster(this.model)
        .then((response) => this.modifyTable(1, this.model.id, response))
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showMessageAccess();
    }
  },
  deleteRecord() {
    if (this.isDelete()) {
      this.showHideLoading(true);
      this.model.route = this.getRoute;
      Axios.destroyMaster(this.model)
        .then((response) => this.modifyTable(1, this.model.id, response))
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showMessageAccess();
    }
  },
  refreshTable() {
    this.$emit('refresh', true);
  },
  /**
   * Método para generar el llamado al endpoint de guardar o crear
   * los datos almacenados en el formulario, luego de la validación en
   * el método de validateForm
   */
  addEdit() {
    this.showHideLoading(true);
    if (this.model.route == this.getRoute) {
      Axios.updateMaster(this.model)
        .then((response) => {
          setTimeout(() => {
            this.$emit('submitUpload', this.model.id);
          }, 100);
          this.modifyTable(1, this.model.id, response);
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.model.route = this.getRoute;
      Axios.saveMaster(this.model)
        .then((response) => {
          setTimeout(() => {
            this.$emit('submitUpload', response.data.data.id);
          }, 100);
          this.modifyTable(0, response.data.data.id, response);
        })
        .catch((error) => {
          this.showMessageErrors(error);
          delete this.model.route;
        });
    }
  },
};

export default methods;
